import React from 'react';
import { Link } from 'react-router-dom';
import './Sections.css';

const Section5 = () => {
  return (
    <section className="section-5">
      {/* Full Width White Band */}
      <div className="section-5-white-band-full">
        <div className="paycis-container">
          <div className="section-5-wrapper">
            <div className="section-5-text">
              <h2 className="section-5-headline">
                PayCIS is built by contractors, <br />
                for contractors.
              </h2>
              <p className="section-5-paragraph">
                We dealt with the same problems — onboarding subbies, sorting payments, 
                fixing mistakes, and wasting hours every week. So we built a system to fix it.
              </p>
              <p className="section-5-paragraph">
                It took us from 5 to 50 workers without needing admin staff, removed payment 
                errors, and made everything run properly.
              </p>
              <p className="section-5-paragraph">
                The auto self-employment contracts also protected us from bogus claims from bad actors.
              </p>
              <p className="section-5-paragraph last-paragraph">
                Now we're bringing the same system to other contractors. 
              </p>
              <div className="section-5-button-wrapper">
                <Link to="/learn-more" className="section-5-learn-more-btn">
                  Learn more →
                </Link>
              </div>
            </div>
            <div className="section-5-image">
              <img 
                src="/images/construction-site.jpg" 
                alt="Construction team working together"
                className="construction-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/contruction_image.jpeg";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section5;